import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Home',
    href: '#home'
  }, {
    name: 'Services',
    href: '#services'
  }, {
    name: 'How It Works',
    href: '#how-it-works'
  }, {
    name: 'About',
    href: '#about'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md py-3' : 'bg-transparent py-4 md:py-6'}`} data-id="element-13">
      <div className="container mx-auto px-4 md:px-6 flex items-center justify-between" data-id="element-14">
        {/* Logo */}
        <a href="#home" className="flex items-center gap-2 z-50 relative" data-id="element-15">
          <div className="w-8 h-8 bg-apex-green rounded-sm flex items-center justify-center" data-id="element-16">
            <span className="text-white font-extrabold text-xl leading-none tracking-tighter" data-id="element-17">
              A
            </span>
          </div>
          <span className={`font-extrabold text-xl tracking-tight ${isScrolled ? 'text-apex-charcoal' : 'text-white'}`} data-id="element-18">
            APEX
          </span>
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8" data-id="element-19">
          {navLinks.map(link => <a key={link.name} href={link.href} className={`text-sm font-semibold uppercase tracking-wider transition-colors hover:text-apex-green ${isScrolled ? 'text-gray-600' : 'text-white/90'}`} data-id="element-20">
              {link.name}
            </a>)}
          <a href="#contact" className="bg-apex-green hover:bg-green-600 text-white px-6 py-2.5 rounded-md font-bold transition-all shadow-sm hover:shadow-md hover:-translate-y-0.5" data-id="element-21">
            Get A Quote
          </a>
        </nav>

        {/* Mobile Toggle */}
        <button className={`md:hidden z-50 relative p-2 -mr-2 ${isScrolled || mobileMenuOpen ? 'text-apex-charcoal' : 'text-white'}`} onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu" data-id="element-22">
          {mobileMenuOpen ? <X className="w-6 h-6" data-id="element-23" /> : <Menu className="w-6 h-6" data-id="element-24" />}
        </button>

        {/* Mobile Menu Overlay */}
        <div className={`fixed inset-0 bg-white z-40 flex flex-col items-center justify-center gap-8 transition-transform duration-300 ease-in-out md:hidden ${mobileMenuOpen ? 'translate-x-0' : 'translate-x-full'}`} data-id="element-25">
          {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setMobileMenuOpen(false)} className="text-2xl font-extrabold text-apex-charcoal uppercase tracking-wider" data-id="element-26">
              {link.name}
            </a>)}
          <a href="#contact" onClick={() => setMobileMenuOpen(false)} className="bg-apex-green text-white px-8 py-4 rounded-md font-bold text-lg w-full max-w-[280px] text-center mt-4" data-id="element-27">
            Get A Quote
          </a>
        </div>
      </div>
    </header>;
}